import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { IntelligenceDataEntryRoutingModule } from './intelligence-data-entry-routing.module';
import { FormsComponent } from './containers/forms/forms.component';
import { FormsFilterComponent } from './components/forms-filter/forms-filter.component';
import { FormsTableComponent } from './components/forms-table/forms-table.component';
import {SharedModule} from '../shared/shared.module';
import {ReactiveFormsModule} from '@angular/forms';
import { EditFormsComponent } from './components/edit-forms/edit-forms.component';


@NgModule({
  declarations: [
    FormsComponent,
    FormsFilterComponent,
    FormsTableComponent,
    EditFormsComponent
  ],
  imports: [
    CommonModule,
    IntelligenceDataEntryRoutingModule,
    SharedModule,
    ReactiveFormsModule,
  ]
})
export class IntelligenceDataEntryModule { }
